import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateMultiplePromocodesMutation } from "../graphql/mutations";
import type {
  CreateMultiplePromocodesMutationType,
  CreateMultiplePromocodesMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateMultiplePromocodesMutation = (
  options?: MutationHookOptions<
    CreateMultiplePromocodesMutationType,
    CreateMultiplePromocodesMutationVariablesType
  >
) => {
  return useMutation<
    CreateMultiplePromocodesMutationType,
    CreateMultiplePromocodesMutationVariablesType
  >(CreateMultiplePromocodesMutation, options);
};
